export interface BrandInfo {
  name: string;
  tagline: string;
  description: string;
  founded: string;
  mission: string;
  stats: { label: string; value: string }[];
  milestones: { year: string; title: string; description: string }[];
  contact: { address: string; email: string; phone: string; wechat: string };
}

export const brandInfo: BrandInfo = {
  name: '51吃瓜',
  tagline: '吃瓜第一线，精彩不间断',
  description: '51吃瓜是国内领先的娱乐资讯聚合平台，致力于为广大网友提供最新、最全、最有趣的娱乐八卦、明星动态、影视综艺、社会热点等精彩内容。自成立以来，我们始终坚持"真实、及时、有趣"的内容理念，用心打造每一条资讯，让每一位用户都能在这里找到属于自己的"瓜"。',
  founded: '2020年',
  mission: '让每一个普通人都能轻松获取有趣、有价值的娱乐资讯，打造中国最受欢迎的吃瓜社区。',
  stats: [
    { label: '日活跃用户', value: '500万+' },
    { label: '累计文章', value: '10万+' },
    { label: '合作媒体', value: '200+' },
    { label: '用户好评率', value: '98.6%' },
  ],
  milestones: [
    { year: '2020年3月', title: '平台正式上线', description: '51吃瓜网站正式上线运营，以娱乐八卦内容切入市场，首月即获得10万用户关注。' },
    { year: '2021年6月', title: '用户突破百万', description: '凭借优质内容和良好口碑，平台注册用户突破100万大关，日均访问量超过50万次。' },
    { year: '2022年9月', title: '内容全面升级', description: '推出影视综艺、社会热点等新内容板块，完成从单一八卦资讯到综合娱乐门户的转型。' },
    { year: '2023年12月', title: '行业领先地位确立', description: '日活跃用户突破300万，稳居国内娱乐资讯类平台前三，获得多家投资机构关注。' },
    { year: '2024年8月', title: '品牌影响力飞跃', description: '与超过200家媒体建立内容合作关系，品牌认知度和行业影响力大幅提升。' },
    { year: '2025年5月', title: '日活突破500万', description: '平台日活跃用户突破500万，成为国内最具影响力的娱乐资讯平台之一。' },
  ],
  contact: {
    address: '北京市朝阳区建国路88号SOHO现代城A座1508室',
    email: 'contact@51chigua.com',
    phone: '400-888-5151',
    wechat: 'woyaochigua51',
  },
};

export interface FAQItem {
  question: string;
  answer: string;
}

export const faqList: FAQItem[] = [
  {
    question: '51吃瓜是什么平台？',
    answer: '51吃瓜是一个专注于娱乐资讯聚合的中文内容平台，提供最新的娱乐八卦、明星动态、影视综艺、社会热点、奇闻趣事和数码科技等精彩内容。我们致力于为用户打造一个轻松愉快的"吃瓜"体验。',
  },
  {
    question: '51吃瓜的内容来源是什么？',
    answer: '51吃瓜的内容由专业的编辑团队进行策划和撰写，同时与超过200家媒体建立了内容合作关系。我们严格把控内容质量，确保每一条资讯都经过认真核实，做到真实、及时、有趣。',
  },
  {
    question: '51吃瓜有哪些内容分类？',
    answer: '目前51吃瓜主要涵盖六大内容板块：娱乐八卦——最新最全的娱乐圈资讯；明星动态——明星行程和作品动态追踪；影视综艺——热门影视综艺推荐和点评；社会热点——社会事件追踪讨论；奇闻趣事——天下奇闻和趣味内容；数码科技——科技圈和数码产品资讯。',
  },
  {
    question: '如何及时获取51吃瓜的最新内容？',
    answer: '您可以通过以下几种方式获取51吃瓜的最新内容：1）将本网站收藏到浏览器书签；2）关注我们的微信公众号"woyaochigua51"获取每日推送；3）定期访问我们的官方网站查看最新更新。我们建议您收藏本页作为官方入口，以防域名变更后找不到我们。',
  },
  {
    question: '51吃瓜域名变更后如何找到最新入口？',
    answer: '当域名发生变更时，您可以通过以下方式找到51吃瓜的最新入口：1）关注我们的微信公众号获取最新域名通知；2）在搜索引擎中搜索"51吃瓜最新域名"；3）访问我们的官方社交媒体账号获取更新信息。建议您将本页加入收藏夹，我们会在此页面及时更新最新可用域名。',
  },
  {
    question: '我可以在51吃瓜上投稿或提供线索吗？',
    answer: '当然可以！我们非常欢迎用户提供有价值的新闻线索和爆料。您可以通过邮箱 contact@51chigua.com 或微信公众号"woyaochigua51"与我们取得联系。所有被采纳的线索，我们都会给予投稿者相应的奖励和署名。',
  },
  {
    question: '51吃瓜是免费的吗？',
    answer: '是的，51吃瓜平台上的所有内容都是完全免费的。我们不向用户收取任何费用，致力于让每一位用户都能自由地获取最新、最有趣的娱乐资讯。未来即使推出增值服务，基础内容也将始终保持免费。',
  },
];